module.exports = __webpack_public_path__ + "img/html-evolution-17.8ec85ba4.webp";